import {
  declarePluralStringWithPlaceholders,
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const PromptsDisplayed = declarePluralStringWithPlaceholders(
  "promptLibrary.promptsDisplayed",
  {
    strings: ({ promptCount }) => {
      return {
        one: `${promptCount} prompt displayed`,
        other: `${promptCount} prompts displayed`,
      };
    },
    comment:
      "The number of prompts displayed on screen. 'prompt' is the text input provided to AI model like GPT",
    placeholders: {
      promptCount: "the number of prompts",
    },
  }
);

export const PromptsRequestFailed = declareString(
  "promptLibrary.promptsRequestFailed",
  {
    text: "Sorry, we're having connection problems. Refresh your browser or come back later.",
    comment:
      "Announcement displayed on the screen when the request to fetch Copilot prompts from the server-side fails.",
  }
);

export const PromptGridDescription = declareString(
  "promptLibrary.promptGridDescription",
  {
    text: "Press Enter to insert a prompt.",
    comment:
      "Aria description being read to users when prompt grid is focused. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout. Enter in this context means keyboard's enter key.",
  }
);

export const PromptGridNoTeamsSuccessTitle = declareString(
  "promptLibrary.promptGridNoTeamsSuccessTitle",
  {
    text: "You don't have any team prompts yet",
    comment:
      "Aria description displayed when a user is not member of any group.",
  }
);

export const PromptGridNoTeamsSuccessDescription =
  declareStringWithPlaceholders(
    "promptLibrary.promptGridNoTeamsSuccessDescription",
    {
      text: ({ learnMore }) =>
        `Create a team to share prompts within your organization. ${learnMore}`,
      comment:
        "Aria description being read to users when prompt grid is focused. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout.",
      placeholders: {
        learnMore: "Learn more link",
      },
    }
  );

export const PromptGridLearnMoreLinkLabel = declareString(
  "promptLibrary.promptGridLearnMoreLinkLabel",
  {
    text: "Learn more",
    comment: "Link label to learn more.",
  }
);

export const PromptGridNoTeamsSuccessButtonLabel = declareString(
  "promptLibrary.promptGridNoTeamsSuccessButtonLabel",
  {
    text: "Explore other prompts",
    comment: "Button label to explore other prompts.",
  }
);

export const PromptGridTeamsNoPromptsMemberSuccessTitle = declareString(
  "promptLibrary.promptGridTeamsNoPromptsMemberSuccessTitle",
  {
    text: "You don't have any team prompts yet",
    comment:
      "Aria description displayed when a user is not member of any group.",
  }
);

export const PromptGridTeamsNoPromptsMemberSuccessButtonLabel = declareString(
  "promptLibrary.promptGridTeamsNoPromptsMemberSuccessButtonLabel",
  {
    text: "Explore other prompts",
    comment: "Button label to explore prompts.",
  }
);

export const PromptGridTeamsNoPromptsOwnerSuccessTitle = declareString(
  "promptLibrary.promptGridTeamsNoPromptsOwnerSuccessTitle",
  {
    text: "You don't have any team prompts yet",
    comment:
      "Aria description displayed when a user is not member of any team.",
  }
);

export const PromptGridTeamsNoPromptsOwnerSuccessDescription = declareString(
  "promptLibrary.promptGridTeamsNoPromptsOwnerSuccessDescription",
  {
    text: "Select the menu on a prompt card to share it to a team.",
    comment:
      "Aria description being read to users when prompt grid is focused. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout.",
  }
);

export const PromptGridTeamsNoPromptsOwnerSuccessButtonLabel = declareString(
  "promptLibrary.promptGridTeamsNoPromptsOwnerSuccessButtonLabel",
  {
    text: "Share prompts to teams",
    comment: "Button label to share prompts to a group.",
  }
);

export const PromptGridTeamsNoPromptsOwnerSuccessDescriptionCannotShareV2 =
  declareString(
    "promptLibrary.promptGridTeamsNoPromptsOwnerSuccessDescriptionCannotShareV2",
    {
      text: "Use Copilot Prompt Gallery to share prompts to your team.",
      comment:
        "Aria description being read to users when prompt grid is focused. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout.",
    }
  );

export const PromptGridTeamsNoPromptsOwnerSuccessButtonLabelCannotShareV2 =
  declareString(
    "promptLibrary.promptGridTeamsNoPromptsOwnerSuccessButtonLabelCannotShareV2",
    {
      text: "Open Copilot Prompt Gallery",
      comment: "Button label to navigate to Copilot Prompt Gallery.",
    }
  );

export const PromptGridTeamsAnnouncementHeader = declareString(
  "promptLibrary.promptGridTeamsAnnouncementHeader",
  {
    text: "We’re making some improvements",
    comment: "Header for team prompts announcement.",
  }
);

export const PromptGridTeamsAnnouncementDescription = declareString(
  "promptLibrary.promptGridTeamsAnnouncementDescription",
  {
    text: "If you’ve previously shared a prompt to a team, try sharing one to the team again. This will make it easier to find and filter by teams that have prompts.",
    comment: "Description for team prompts announcement.",
  }
);

export const PromptGridTeamsNoPromptsOwnerSuccessDescriptionOuter =
  declareStringWithPlaceholders(
    "promptLibrary.PromptGridTeamsNoPromptsOwnerSuccessDescriptionOuter",
    {
      text: ({ action }) =>
        `Select ${action} on a prompt card to share a prompt to a team.`,
      comment:
        "Message shown on team prompt grid when no prompts have been shared. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout.",
      placeholders: {
        action: "Action to be displayed in bold is Share",
      },
    }
  );

export const PromptGridTeamsNoPromptsOwnerSuccessDescriptionInner =
  declareString(
    "promptLibrary.PromptGridTeamsNoPromptsOwnerSuccessDescriptionInner",
    {
      text: "Share",
      comment:
        "Action to be displayed in bold in promptLibrary.PromptGridTeamsNoPromptsOwnerSuccessDescriptionOuter-resource instead of action-placeholder.",
    }
  );
